// Used to determine if a color is very light in color, hence 'whiteish'

import { getPerceivedBrightness } from './get-perceived-brightness.helper';

// Can be usefull if you know the element would be near (or fully) invisible, if the color/background/etc. is too light
export const isWhiteish = (color: string): boolean => {
    if (color.toLowerCase() === 'white') {
        return true;
    }
    if (color[0] !== '#') {
        return false;
    }

    return getPerceivedBrightness(color) > 235;
};
